// extracted by mini-css-extract-plugin
export default {"wrapper":"MemberAreaContainer_wrapper__ycI94","container":"MemberAreaContainer_container__lgJtx"};